<template>
	<div class="col-12 mt-3" id="partner-us">
		<div class="col-12 color-mila text-center font-size-20 font-size-sm-10 font-weight-bold">Partner Kami</div>
		<div class="col-12 text-center font-size-15 font-size-sm-6">Partner terbaik kami yang senantiasa memberikan kebaikan untuk anda</div>

		<carousel class="col-12 partner-index mt-3 mb-5" :responsive="{0:{items:1},600:{items:5}}" :autoplay="true" :nav="false" :loop="true">
			<div class="offset-2 col-8 offset-md-0 col-md-12 item" v-for="(value, index) in partner" :key="index">
				<img class="img-fluid m-auto" :src="value.url" :alt="value.name">
			</div>
		</carousel>
	</div>
</template>

<script>
	import carousel from 'vue-owl-carousel';

	export default {
		name: 'MlPartnerUs',
		components: {
			carousel,
		},
		data(){
			return {
				partner:[
				{name: 'bca', url: '/assets/partner/bca.png'},
				{name: 'mandiri', url: '/assets/partner/mandiri.png'},
				// {name: 'gojek', url: '/assets/partner/gojek.png'},
				// {name: 'grab', url: '/assets/partner/grab.png'},
				{name: 'jne', url: '/assets/partner/jne.png'},
				{name: 'lion', url: '/assets/partner/lion.png'},
				{name: 'pos', url: '/assets/partner/pos.png'},
				{name: 'jnt', url: '/assets/partner/jnt.png'},
				{name: 'tiki', url: '/assets/partner/tiki.png'},
				{name: 'great system', url: '/assets/partner/gs.png'},
				],
			}
		},
	}
</script>

<style>
.partner-index .item img {
	width: 150px !important;
}
</style>